module.exports = __webpack_public_path__ + "static/media/point_1.754f2656.svg";